import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectStreet, selectCity, selectPostalCode, selectInvoiceStreet, selectInvoiceCity, selectInvoicePostalCode } from '@store/order/selectors';



const CustomerAddress = () => {
	const { t } = useTranslation('forms');

	const invoiceStreet = useSelector(selectInvoiceStreet);
	const invoiceCity = useSelector(selectInvoiceCity);
	const invoicePostalCode = useSelector(selectInvoicePostalCode);

	const street = useSelector(selectStreet);
	const city = useSelector(selectCity);
	const postalCode = useSelector(selectPostalCode);

	const existDeliveryAddress = street && city && postalCode ? true : false;

	return (
		<>
			<div className='order-summary-element'>

				<h2>{existDeliveryAddress ? t('customerAddress.invoiceAddress') : t('customerAddress.address')}</h2>

				<div className='summary-grid'>

					<p>{t('inputLabels.street') + ':'}</p>
					<p>{invoiceStreet ? invoiceStreet : '-'}</p>

					<p>{t('inputLabels.city') + ':'}</p>
					<p>{invoiceCity ? invoiceCity : '-'}</p>

					<p>{t('inputLabels.postalCode') + ':'}</p>
					<p>{invoicePostalCode ? invoicePostalCode : '-'}</p>

				</div>

			</div>

			{existDeliveryAddress &&
				<div className='order-summary-element'>

					<h2>{t('customerAddress.deliveryAddress')}</h2>

					<div className='summary-grid'>

						<p>{t('inputLabels.street') + ':'}</p>
						<p>{street ? street : '-'}</p>

						<p>{t('inputLabels.city') + ':'}</p>
						<p>{city ? city : '-'}</p>

						<p>{t('inputLabels.postalCode') + ':'}</p>
						<p>{postalCode ? postalCode : '-'}</p>

					</div>

				</div>}
		</>
	);
};

export default CustomerAddress;